// extracted by mini-css-extract-plugin
module.exports = {"Certification":"Certification_Certification__KQz6A"};